module.exports = __webpack_public_path__ + "assets/code.b0f7b3e8.svg";